import { HeadingH1 } from '@dreamstack/feature-components/src/layout/Texts'
import type { FunctionComponent } from 'react'
import { padZero } from './HighlightRealEstateItem'

export const HighlightRealEstatePageNumber: FunctionComponent<
  React.PropsWithChildren<{
    index: number
    length: number
  }>
> = ({ index, length }) => {
  const page = index + 1
  const formattedPageNumber = padZero(page, 2)
  const formattedLength = padZero(length, 2)
  return (
    <div className="text-center relative lg:static">
      <HeadingH1 className="tabular-nums md:py-px-12 lg:py-px-24">
        {formattedPageNumber}
      </HeadingH1>
      <HeadingH1 className="text-accentroGray-400 absolute -bottom-full tabular-nums md:py-px-12 lg:py-px-24">
        {formattedLength}
      </HeadingH1>
    </div>
  )
}
